import { userFullName } from "@equidefi/shared";
import { DTO } from "@equidefi/shared/types";
import { v4 as uuidv4 } from "uuid";

const KEY = "investor_session_id";

function fullviewSessionId(): string {
  const existing = window.localStorage.getItem(KEY);
  if (existing) return existing;
  const id = uuidv4();
  window.localStorage.setItem(KEY, id);
  return id;
}

export type FullviewIdentity = {
  id: string;
  name: string;
  email?: string;
  disableReplaysForUser?: boolean;
  env?: string;
  investor_session_id: string;
  [key: string]: string | number | boolean | undefined;
};

export const identifyFullview = (user: DTO.User, appEnv: string) => {
  if (typeof window === "undefined") return;
  if (!appEnv || appEnv !== "production") return;

  const sessionId = fullviewSessionId();

  const identity: FullviewIdentity = {
    id: user?.id ? String(user.id) : `visitor-${sessionId}`, // Required
    name: user?.id ? userFullName(user) : `Anonymous`, // Required
    email: user?.email, // Optional
    disableReplaysForUser: false, // Optional
    env: process.env.NODE_ENV, // Optional
    investor_session_id: sessionId, // Optional
  };

  //@ts-ignore
  window.$fvIdentity = identity;
};
